import styled from '@emotion/styled';
import Colors from '../../../components/theme/colors';
import HorizontalFlex from '../../../components/flex_layouts/HorizontalFlex';
import { useAppContext } from '../../../context/AppContext';

const TableSearchField = ({ ...props }) => {
  const { freeSearchText, setFreeSearchText } = useAppContext();

  const handleChange = (e: any) => {
    setFreeSearchText(e.target.value);
  };

  return (
    <LayoutRoot {...props}>
      <img src="/search.svg" alt="Search Icon" />
      <Input
        value={freeSearchText}
        onChange={handleChange}
        placeholder={'Enter search item (e.g: Line of treatment, Drug)'}
      ></Input>
    </LayoutRoot>
  );
};
export default TableSearchField;

const LayoutRoot = styled(HorizontalFlex)`
  border-radius: 100px;
  gap: 6px;
  padding: 10px;
  border: 1px solid ${Colors.gray_4};
  background: ${Colors.white};
  max-width: 365px;
  height: 44px;
  width: 100%;

  @media print {
    display: none;
  }
`;

const Input = styled.input`
  height: 100%;
  width: 100%;
  ::placeholder {
    color: ${Colors.gray_3};
    font-size: 14px;
    font-weight: 300;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.3px;
  }
`;
